import { render, staticRenderFns } from "./studyReport.vue?vue&type=template&id=0dcb9a92&scoped=true&"
import script from "./studyReport.vue?vue&type=script&lang=js&"
export * from "./studyReport.vue?vue&type=script&lang=js&"
import style0 from "./studyReport.vue?vue&type=style&index=0&id=0dcb9a92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcb9a92",
  null
  
)

export default component.exports